module App.View

open Elmish
open Elmish.Navigation
open Elmish.UrlParser
open Fable.Core.JsInterop
open Types
open App.State
open Global
open Fable.React
open Fable.React.Props
open Fulma
open Elmish.React
open Elmish.Debug
open Elmish.HMR

importAll "../sass/main.sass"

let private link page label = a [ Href (toHash page) ] [ str label ]

let menuItem label page currentPage =
    Fulma.Tabs.tab
      [ Fulma.Tabs.Tab.IsActive (page = currentPage) ]
      [ link page label ]

let private logout =
    form
        [ Action "/account/signout"; Method "post" ]
        [ Button.button [ Button.Option.Props [ Type "submit" ] ] [ str "Sign out" ] ]

let menu model =

    let mainPages = [
        menuItem "Home" Page.Home
        menuItem "Applications" Page.Applications
    ]

    let otherPages =
        model.PluginPages
        |> Option.map (fun i -> i.pages |> List.map (fun ii -> menuItem (ii.code) (Page.Plugin ii.code)))
        |> Option.defaultValue []

    Container.container
        []
        [
            Columns.columns
                [ Columns.IsMobile ]
                [ 
                    Column.column [
                        Column.Width(Screen.All, Column.IsNarrow)
                        Column.Modifiers [ Modifier.IsHidden (Screen.Mobile, true) ] ]
                        [ a [ Href "#home" ] [ img [ Src "img/logo-52x52.png"; HTMLAttr.Width 52; HTMLAttr.Height 52;] ] ]
                    Column.column [] [
                        Fulma.Tabs.tabs
                            [ ]
                            [ ul [] ((mainPages@otherPages) |> List.map (fun i -> i model.CurrentPage)) ]
                    ]
                    Column.column
                        [ Column.Width(Screen.All, Column.IsNarrow) ]
                        [ logout ]
                ]
        ]

let requiresIam model view =
  match model.IamEditorUrl with
  | None -> str "No IAM url"
  | Some iam -> view iam

let root model dispatch =

  let pageHtml page =
    match page with
    | Page.Home -> Home.view model
    | Page.Applications ->
      match model.Applications with
      | None -> str "Loading"
      | Some s -> requiresIam model (fun iam -> Applications.view iam s (Types.Msg.Applications >> dispatch))
    | Page.ApplicationsWithParameters _ ->
        match model.Applications with
        | None -> str "Loading"
        | Some s ->
            requiresIam model (fun iam -> Applications.view iam s (Types.Msg.Applications >> dispatch))
    | Page.Plugin code ->
      match model.PluginPages with
      | None -> Fulma.Progress.progress [] []
      | Some pages ->
        match pages.pages |> List.tryFind (fun i -> i.code = code) with
        | None -> str "Unknown page"
        | Some p ->
          div
            [ Class "plugin-container stretch-height" ]
            [ (AppHost.editorWithIam p.appUrl p.uiUrl (                
                match model.Applications with
                | None -> ""
                | Some s -> Applications.getLanguages s)) |> requiresIam model ]

  div
    [ Class "stretch-height" ]
    [
      menu model
      div
        [ Class "page-container is-spaced" ]
        [ Container.container
            [ Container.CustomClass "stretch-height" ]
            [ pageHtml model.CurrentPage ]
        ]
    ]

// App
Program.mkProgram init update root
|> Program.toNavigable (parseHash pageParser) urlUpdate
#if DEBUG
|> Program.withDebugger
#endif
|> Program.withConsoleTrace
|> Program.withReactBatched "elmish-app"
|> Program.run
